module.exports = __webpack_public_path__ + "4b3b72e714f5f0b2f1479a065c006ee5.png";